<template>
    <div>
        <van-button class="btn btn-text" @click="onBtnClick">
            <div class="bh bstart" :class="[isActivate?'':'activate']">
                <span class="fz_30 overflow text" :class="selectClass">{{text}}</span>
                <div class="bv bc btn-ico" :class="[isHidden?'hidden':'']">
                    <div class="btn-ico-el ico-yellowtriangle"></div>
                </div>
            </div>
        </van-button>
    </div>
</template>

<script>
import StateButton from "./State";
export default {
    extends: StateButton,
    name: "FoldButton",
    props: {
        selectClass: null
    },
    data() {
        return {
            isHidden: false
        };
    },
    methods: {
        // 重置
        reset() {
            const me = this;
            me.isHidden = false;
            me.isActivate = false;
            me.$emit("activateChange", me.isActivate);
        }
    }
};
</script>

<style scoped lang="scss">
.text {
    max-width: 5em;
}
.btn-ico {
    margin-left: 12px;
}
.btn-ico-el {
    width: 16px;
    height: 16px;
}
.ico-yellowtriangle {
    background-image: url("~@/assets/imges/ico/yellowtriangle.png");
}
[data-theme="app"] {
    .ico-yellowtriangle {
        background-image: url("~@/assets/imges/app/ico/yellowtriangle.png");
    }
}
.activate {
    .btn-ico {
        @include rotate(180deg);
    }
}
</style>

